import Cookies from 'js-cookie';

const ATTRIBUTES: Cookies.CookieAttributes = {
  path: '/',
  secure: true,
  sameSite: 'Strict',
  domain: '.' + window.location.hostname.split('.').slice(-2).join('.'), // i.e. '.autodesk.com' or '.autodesk.eu'
  expires: 30,
} as const;

/**
 * Utility class for setting, getting, and removing cookies.
 */
class CookiesUtil {
  static set(key: string, value: string): void {
    Cookies.set(key, value, ATTRIBUTES);
  }

  static get(key: string): string | undefined {
    return Cookies.get(key);
  }

  static remove(key: string): void {
    Cookies.remove(key, ATTRIBUTES);
  }
}

export default CookiesUtil;
